import { RenderUnsettledUI } from 'shared/components';
import { FlexWorkerTableOptions } from 'shared/components/flex-workers-for-work-table/flex-workers-for-work-table.types';
import { FlexWorkersForProjectFilters } from 'shared/components/flex-workers-for-work-table/flex-workers-for-work.types';
import { DEFAULT_PAGE_SIZE } from 'shared/utils/constants';
import { FlexWorkersTable } from '../../../../flex-workers-for-work-table/flex-workers-table';
import { useGetFlexWorkersForProject } from '../applications/hooks/get-flex-workers-for-project';

type ProviderProps = {
  projectDetails: {
    projectId: string;
    isFreelance: boolean;
    isTempWork: boolean;
  };
  filters?: FlexWorkersForProjectFilters;
  getRowActions: FlexWorkerTableOptions['getRowActions'];
};

export const CreatePlacementTableProvider = ({
  filters,
  projectDetails,
  getRowActions,
}: ProviderProps) => {
  const flexWorkerQuery = useGetFlexWorkersForProject(
    projectDetails.projectId,
    DEFAULT_PAGE_SIZE,
    filters
  );
  const { status } = flexWorkerQuery;

  if (status !== 'success') {
    return <RenderUnsettledUI data={flexWorkerQuery} />;
  }

  return (
    <FlexWorkersTable
      queryResult={flexWorkerQuery}
      entityId={projectDetails.projectId}
      getRowActions={getRowActions}
      showAvailabilityColumn={true}
    />
  );
};
